<ada-container
	padding="{{ ui.Spacing.SPACING_LARGE }}"
	[colCount]="4"
	[horizontalSpacing]="'Medium'"
	[verticalSpacing]="'Medium'"
>
	<ada-container
		[colCount]="0"
		[horizontalSpacing]="'Small'"
		[verticalAlignmentOfChildren]="'Middle'"
	>
		<ada-text [content]="'Discovery Mode'" />
		<ada-signpost>
			<ada-container [verticalSpacing]="'Medium'">
				<ada-container
					[colCount]="0"
					[horizontalSpacing]="'Small'"
				>
					<ada-text
						[content]="'Offline Mode -'"
						[fontWeight]="'Bold'"
					/>
					<ada-text
						content="No {{ systemConfig.appDisplayName | async }} server or client will be able to connect to this cloud relay server"
					/>
				</ada-container>
				<ada-container
					[colCount]="0"
					[horizontalSpacing]="'Small'"
				>
					<ada-text
						[content]="'Test Mode -'"
						[fontWeight]="'Bold'"
					/>
					<ada-text
						content="{{ systemConfig.appDisplayName | async }}'s test servers and clients will be able to connect with this server"
					/>
				</ada-container>
				<ada-container
					[colCount]="0"
					[horizontalSpacing]="'Small'"
				>
					<ada-text
						[content]="'Production Mode -'"
						[fontWeight]="'Bold'"
					/>
					<ada-text [content]="'Customers\' production servers and clients will be able to connect with this server'" />
				</ada-container>
			</ada-container>
		</ada-signpost>
	</ada-container>
	<ada-container [colSpan]="3">
		<ada-radio-button
			data-testid="discovery-mode-radio-button"
			id="DiscoveryModeRadioButton"
			[buttons]="discoveryModeOptions"
			[(value)]="context.discoveryMode"
		/>
	</ada-container>
	<ada-alert
		*ngIf="errors.geolocation | async as msg"
		[colSpan]="4"
		[isClosable]="false"
		[title]="msg"
		[type]="'Error'"
	/>
	<ada-vector2
		xLabel="Longitude"
		xLabelInfo="Supply a longitude value between -180 and 180"
		yLabel="Latitude"
		yLabelInfo="Supply a latidude value between -90 and 90"
		[colSpan]="4"
		[max]="geolocationMax"
		[min]="geolocationMin"
		[value]="geolocation"
		(valueChange)="setGeolocation($event)"
	/>
</ada-container>
